import React from 'react'
import {
  List, Datagrid, TextField, EditButton,
} from 'react-admin'

import AccountListFilter from './AccountListFilter'

const AccountList = props => (
  <List
    {...props}
    sort={{ field: 'name', order: 'ASC' }}
    bulkActions={false}
    filters={<AccountListFilter />}
  >
    <Datagrid>
      <TextField source="name" />
      <TextField source="type" />
      <EditButton />
    </Datagrid>
  </List>
)

export default AccountList
